import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { restablecerPassword } from './services/auth';
import './Restablecer.css';

function Restablecer() {
  const [nuevaPassword, setNuevaPassword] = useState('');
  const [confirmarPassword, setConfirmarPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extraer el token de la URL
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      setError('Token de recuperación no encontrado. Verifica el enlace del correo.');
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    // Validar que las contraseñas coincidan
    if (nuevaPassword !== confirmarPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    // Validar longitud mínima
    if (nuevaPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      const response = await restablecerPassword(token, nuevaPassword);
      setSuccess('¡Contraseña actualizada correctamente! Redirigiendo al login...');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.message || 'Error al restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* IZQUIERDA - BRANDING */}
      <div className="login-branding">
        <div className="login-branding__content">
          <img 
            src="/sinteligen4.png" 
            alt="Sinteligen" 
            className="login-branding__logo"
          />
          <p className="login-branding__subtitle">
            SOLUCIONES TECNOLÓGICAS INTELIGENTES
          </p>
        </div>

        <div className="login-branding__orb login-branding__orb--1" />
        <div className="login-branding__orb login-branding__orb--2" />
      </div>

      {/* DERECHA - FORMULARIO */}
      <div className="login-form-side">
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-form__header">
            <h2>Restablecer Contraseña</h2>
            <p>Ingresa tu nueva contraseña</p>
          </div>

          {error && <div className="login-error">{error}</div>}
          {success && <div className="login-success">{success}</div>}

          <div className="login-form__field">
            <label>Nueva Contraseña</label>
            <input
              type="password"
              value={nuevaPassword}
              onChange={(e) => setNuevaPassword(e.target.value)}
              required
              placeholder="Mínimo 6 caracteres"
              disabled={loading || !token}
            />
          </div>

          <div className="login-form__field">
            <label>Confirmar Contraseña</label>
            <input
              type="password"
              value={confirmarPassword}
              onChange={(e) => setConfirmarPassword(e.target.value)}
              required
              placeholder="Repite tu nueva contraseña"
              disabled={loading || !token}
            />
          </div>

          <button 
            className="login-btn" 
            type="submit" 
            disabled={loading || !token}
          >
            {loading ? 'Actualizando...' : 'Actualizar Contraseña'}
          </button>

          <div className="login-form__footer">
            <p className="login-register-link">
              ¿Recordaste tu contraseña? <button type="button" onClick={() => navigate('/login')} className="link-button">Iniciar Sesión</button>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Restablecer;